import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import ColorSelector from '../common/form/colorSeletor';

import { setModoTela, initForm } from './distribuidoraActions';

class DistribuidoraForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='id_cidade'
								component={Select}
								options={this.props.listaCidade}
								label='Cidade'
								cols='12 12 12 12'
								placeholder='Selecione a cidade'
								readOnly={readOnly} />

							<Field
								name='custo_operacao'
								component={LabelAndInputNumber}
								label='Custo da Operação' placeholder='Informe o custo'
								cols='12 12 12 12'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='latitude'
								component={LabelAndInput}
								label='Latitude (-28.389046)' placeholder='Informe a latitude'
								cols='6 4 3 2'
								readOnly={readOnly} />
								
							<Field
								name='longitude'
								component={LabelAndInput}
								label='Longitude (-53.914509)' placeholder='Informe a latitude'
								cols='6 4 3 2'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='cor'
								component={ColorSelector}
								label='Cor'
								cols='12 10 6 4'
								readOnly={readOnly}
								color={this.props.formularioValues.cor || '#fff'}
								complete={(color) => {
									this.props.initForm({ ...this.props.formularioValues, cor: color.hex });
								}} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

DistribuidoraForm = reduxForm({form: 'distribuidoraForm', destroyOnUnmount: false})(DistribuidoraForm);
const mapStateToProps = state => ({
	sessao: state.auth.distribuidora,
	formularioValues: getFormValues('distribuidoraForm')(state),
	registro: state.distribuidora.registro,
	listaCidade: state.distribuidora.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DistribuidoraForm);
